import React from 'react';

export type SearchTeaserProps = {
  id: string;
  title: string;
  slug: string;
  url: string;
  post_date_timestamp: number;
  section: string;
  headline?: string;
  subline?: string;
  intro?: string;
  format?: string[];
  topic?: string[];
  jobCategory?: string;
  author?: string;
  location?: string[];
  hint?: string;
  start_date_timestamp?: string;
  end_date_timestamp?: string;
  industryMainBranch?: string;
  subsidiaries?: {
    city: string;
    title: string;
  }[];
};

const SearchTeaser = ({
  title,
  headline,
  format,
  topic,
  subline,
  location,
  url,
  section,
  industryMainBranch,
  subsidiaries
}: SearchTeaserProps) => {
  const Tag = url ? 'a' : 'div';

  const getCategories = () => {
    let arr: string[] = [];

    if (format && format.length > 0) {
      arr = [...arr, ...format];
    } else if (topic && topic.length > 0) {
      arr = [...arr, ...topic];
    }

    if (section === 'events') {
      if (location && location.length > 0) {
        arr = [...arr, ...location];
      }
    }

    if (section === 'members') {
      if (industryMainBranch) {
        arr = [...arr, industryMainBranch];
      }
    }

    return arr.filter((i) => i !== '').join(' | ');
  };

  return (
    <Tag href={url} className="search-list__teaser">
      <p className="search-list__categories typo-button font-bold">
        {getCategories()}
      </p>

      <div className="search-list__teaser-headline">
        <svg
          width="31"
          height="30"
          viewBox="0 0 31 30"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            id="Vector"
            d="M15.6392 7L14.2292 8.41L19.8092 14H7.63916V16H19.8092L14.2292 21.59L15.6392 23L23.6392 15L15.6392 7Z"
            fill="currentColor"
          />
          <circle
            id="Ellipse 82"
            cx="15.6391"
            cy="15.0004"
            r="14.5141"
            stroke="currentColor"
            fill="none"
          />
        </svg>

        <p className="typo-headline-3">{headline ?? title}</p>
      </div>
      {subline && <p className="typo-copy">{subline}</p>}

      {section && subsidiaries && subsidiaries.length > 0 && (
        <p className="typo-copy">
          {subsidiaries
            .map((item) => `${item.title} (${item.city})`)
            .join(', ')}
        </p>
      )}
    </Tag>
  );
};

export default SearchTeaser;
